import { CALL_API } from '../middleware/api'

export const ABSENCES_REQUEST = 'ABSENCES_REQUEST'
export const ABSENCES_SUCCESS = 'ABSENCES_SUCCESS'
export const ABSENCES_FAILURE = 'ABSENCES_FAILURE'

export const ADD_ABSENCE_REQUEST = 'ADD_ABSENCE_REQUEST'
export const ADD_ABSENCE_SUCCESS = 'ADD_ABSENCE_SUCCESS'
export const ADD_ABSENCE_FAILURE = 'ADD_ABSENCE_FAILURE'

export const fetchAbsences = (refresh = false) => (dispatch, getState) => {
	const absences = getState().absences;
	const now = Math.floor(Date.now() / 1000);
	if (!refresh && absences && absences.expires >= now) {
		return null
	}
	
	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ ABSENCES_REQUEST, ABSENCES_SUCCESS, ABSENCES_FAILURE ],
			endpoint: '/absences/',
			method: 'POST',
			params: {
				member_no: user.member_no,
			},
			bad_response: 'Error fetching absences from U-MAS database',
		}
	})
}

export const addAbsence = (start_date, finish_date, reason, course_code = null) => (dispatch, getState) => {
	const user = getState().user;
	
	let params = {
		member_no: user.member_no,
		reason: reason,
		start_date: start_date,
		finish_date: finish_date,
	};
	
	if(course_code){
		params.course_code = course_code;
	}
	
	return dispatch({
		[CALL_API]: {
			types: [ ADD_ABSENCE_REQUEST, ADD_ABSENCE_SUCCESS, ADD_ABSENCE_FAILURE ],
			endpoint: '/absences/',
			method: 'PUT',
			params: params,
			bad_response: 'Error adding absence U-MAS database',
		}
	})
}